<template>
  <div></div>
</template>

<script>
    export default {
        mounted() {
            let isEstablishment = this.$store.state.users.user.tipo === 'ESTABELECIMENTO';
            this.$store.commit('SET_USER', null)
            if (isEstablishment){
                this.$router.push({name: 'ADMIN_ESTABLISHMENTS'})
            } else {
                this.$router.push({name: 'ADMIN_ADVERTISERS'})
            }
        }
    }
</script>

<style scoped>
</style>
